import React, { useMemo } from 'react';
// @ts-ignore
import styles from './TherapistInformation.module.scss';
import {
	TermItem,
	useUserMetaTranslationsQuery,
	useUserTermItemsQuery,
} from '../../../../graphql/graphql';
import TherapistInformationItem, {
	TherapistInformationItemInterface,
} from './TherapistInformationItem';
interface Props {
	userId: string;
	onReload: () => void;
}

const TherapistInformation: React.FC<Props> = ({ userId, onReload }) => {
	const termItems = useUserTermItemsQuery({
		id: userId,
	});

	const metaTranslations = useUserMetaTranslationsQuery({
		id: userId,
		keys: [
			'aboutTherapy',
			'educationAndProfileOfTheTherapist',
			'certificatesAndDiplomas',
		],
	});

	const getMetaTranslationByKey = ({
		key,
		item,
	}: {
		key: string;
		item: TermItem;
	}) => {
		return metaTranslations?.data?.user?.metaTranslation?.find(
			metaTranslation =>
				metaTranslation?.language === item.value &&
				metaTranslation?.key === key,
		)?.value;
	};

	const handleReload = () => {
		termItems.refetch();
		metaTranslations.refetch();
		onReload();
	};

	const data = useMemo(() => {
		const tempData: TherapistInformationItemInterface[] = [];
		termItems?.data?.user?.termItems
			?.filter(item => item?.term?.type === 'language_grouped')
			?.forEach(item => {
				if (item?.value) {
					tempData.push({
						language: {
							name: item.name,
							code: item.value,
						},
						items: [
							{
								key: 'aboutTherapy',
								title: 'component.therapistDetail.aboutTherapy',
								value: getMetaTranslationByKey({
									key: 'aboutTherapy',
									item,
								}),
							},
							{
								key: 'educationAndProfileOfTheTherapist',
								title:
									'component.therapistDetail.educationAndProfileOfTheTherapist',
								value: getMetaTranslationByKey({
									key: 'educationAndProfileOfTheTherapist',
									item,
								}),
							},
							{
								key: 'certificatesAndDiplomas',
								title: 'component.therapistDetail.certificatesAndDiplomas',
								value: getMetaTranslationByKey({
									key: 'certificatesAndDiplomas',
									item,
								}),
							},
						],
					});
				}
			});
		return tempData;
	}, [termItems, metaTranslations]);

	return (
		<div className={styles.wrapper2}>
			{data.map((item, key) => {
				return (
					<React.Fragment key={key}>
						<TherapistInformationItem
							userId={userId}
							item={item}
							afterSuccessfulEdit={handleReload}
						/>
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default TherapistInformation;
